// ── Cloud Functions base URL ──────────────────────────────────────────────────
// Production (and any `vite build` output) calls the functions directly, exactly
// as before. The dev server instead calls them through the `/cf` proxy declared
// in vite.config.js, which forwards the request server-side with an Origin the
// deployed withCORS() allowlist accepts — so a localhost run can request and
// verify a security code the same way the live site does.
//
// `import.meta.env.DEV` is replaced with `false` at build time, so the '/cf'
// branch is dead code and is stripped from every production bundle.
export const FN_BASE = import.meta.env.DEV
  ? '/cf'
  : 'https://us-central1-pcakedatastore.cloudfunctions.net';

export default FN_BASE;
